var _a;
import { createActions } from 'redux-actions';
export var getDevice = (_a = createActions('GET_DEVICE', 'GET_DEVICE_COMPLETE', 'GET_DEVICE_THEME'), _a.getDevice), getDeviceComplete = _a.getDeviceComplete, getDeviceTheme = _a.getDeviceTheme;
